import React from "react";
import type { ThreadData } from "@liveblocks/core";
import { useThreadSubscription } from "@liveblocks/react";
import { useLiveblocksUser } from "./useLiveblocksUser";

type Props = {
  thread: ThreadData;
  isOpen: boolean;
  onClick: (e: React.MouseEvent) => void;
};

export const CommentPin: React.FC<Props> = ({ thread, isOpen, onClick }) => {
  const firstCommentAuthorId = thread.comments[0]?.userId;
  const user = useLiveblocksUser(firstCommentAuthorId);
  const subscription = useThreadSubscription(thread.id);
  const unread =
    subscription.status === "subscribed" && subscription.unreadSince
      ? thread.comments.filter((c) => c.body && new Date(c.createdAt) > subscription.unreadSince!).length
      : 0;

  const initial = (user.name || "?").charAt(0).toUpperCase();
  const bg = user.color || "#4f5b94";
  const isResolved = !!thread.resolved;

  return (
    <button
      type="button"
      data-comment-pin
      onClick={onClick}
      onPointerDown={(e) => e.stopPropagation()}
      className={`relative flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-[11px] font-semibold text-white shadow-[0_2px_8px_rgba(16,24,40,0.2)] ring-2 ring-white transition hover:scale-105 ${
        isResolved ? "opacity-60" : ""
      } ${isOpen ? "scale-110" : ""}`}
      style={{
        backgroundColor: bg,
        borderTopLeftRadius: 4,
        borderTopRightRadius: 14,
        borderBottomRightRadius: 14,
        borderBottomLeftRadius: 14,
      }}
      title={user.name || "Comment"}
    >
      {user.avatar ? (
        <img
          src={user.avatar}
          alt={user.name || "user"}
          className="h-full w-full rounded-full object-cover"
          style={{
            borderTopLeftRadius: 2,
            borderTopRightRadius: 12,
            borderBottomRightRadius: 12,
            borderBottomLeftRadius: 12,
          }}
          draggable={false}
        />
      ) : (
        <span className="uppercase">{initial}</span>
      )}
      {unread > 0 && (
        <span className="absolute -right-1 -top-1 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-[#ff4d4f] px-1 text-[10px] font-bold text-white ring-2 ring-white">
          {unread > 9 ? "9+" : unread}
        </span>
      )}
    </button>
  );
};
